import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
const ItemIsReady = (item: SmartSendItemApiModel) =>
  item.Status === 'Active' && item.MarketplaceStatus === 'Sold' && item.State?.validation?.Validated === true;
export default ItemIsReady;
